// extracted by mini-css-extract-plugin
module.exports = {"kort":"SituasjonskortPart_kort__qF_4u","disabled":"SituasjonskortPart_disabled__fiZsX","disabledMsg":"SituasjonskortPart_disabledMsg__URBNf"};